import React, { Component } from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import M from "materialize-css"

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      sidenav: null
    }
    this.closeSidenav = this.closeSidenav.bind(this)
  }

  componentDidMount() {
    const sidenav = M.Sidenav.init(document.getElementById('mobile-menu'))
    this.setState({ sidenav: sidenav })
  }

  closeSidenav() {
    this.state.sidenav.close()
  }

  render() {
    return (
      <header className="header navbar-fixed">
        <nav>
          <div className="nav-wrapper container">
            <a href="#" className="brand-logo">
              <img src={`${process.env.PUBLIC_URL}/assets/images/s-agent.png`} alt="就職エージェント" />
            </a>
            <a href="#" data-target="mobile-menu" className="sidenav-trigger">
              <i className="material-icons">menu</i>
            </a>
            <ul className="menu right hide-on-med-and-down">
              <li>
                <AnchorLink href="#companies" offset="80">過去の参加企業</AnchorLink>
              </li>
              <li>
                <AnchorLink href="#about" offset="80">イベントについて</AnchorLink>
              </li>
              <li>
                <AnchorLink href="#benefit" offset="80">来社特典</AnchorLink>
              </li>
              <li>
                <AnchorLink href="#features" offset="80">特徴</AnchorLink>
              </li>
              <li>
                <AnchorLink href="#timetable" offset="80">スケジュール</AnchorLink>
              </li>
              <li>
                <AnchorLink href="#overview" offset="80">開催概要</AnchorLink>
              </li>
              <li>
                <AnchorLink href="#entry" offset="80">参加予約</AnchorLink>
              </li>
            </ul>
          </div>
        </nav>
        <ul className="sidenav" id="mobile-menu">
          <li>
            <AnchorLink href="#companies" offset="80" onClick={this.closeSidenav} >過去の参加企業</AnchorLink>
          </li>
          <li>
            <AnchorLink href="#about" offset="80" onClick={this.closeSidenav} >イベントについて</AnchorLink>
          </li>
          <li>
            <AnchorLink href="#benefit" offset="80" onClick={this.closeSidenav} >来社特典</AnchorLink>
          </li>
          <li>
            <AnchorLink href="#features" offset="80" onClick={this.closeSidenav} >特徴</AnchorLink>
          </li>
          <li>
            <AnchorLink href="#timetable" offset="80" onClick={this.closeSidenav} >スケジュール</AnchorLink>
          </li>
          <li>
            <AnchorLink href="#overview" offset="80" onClick={this.closeSidenav} >開催概要</AnchorLink>
          </li>
          <li>
            <AnchorLink href="#entry" offset="80" onClick={this.closeSidenav} >参加予約</AnchorLink>
          </li>
        </ul>
      </header>
    )
  }
}

export default Header